export { default as HistorialTraslados } from "./HistorialTraslados";
